import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Ruta protegida: si no hay sesión válida, redirige a /admin/login.
const PrivateRoute = ({ component: Component, children, ...rest }) => {
  const { isAuthenticated } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          Component ? <Component {...props} /> : children
        ) : (
          <Redirect to={{ pathname: '/admin/login', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
